module.exports = __webpack_public_path__ + "img/n.9151a685.jpg";